// noinspection JSUnusedGlobalSymbols
// File auto-generated on: 2025-06-03T15:14:56.941Z

import {
    GetNavigationDataApiResponse,
    GetNavigationDataApiArg,
    GetNavigationMenusApiResponse,
    GetNavigationMenusApiArg,
    GetNavigationMenusByMenuNameApiResponse,
    GetNavigationMenusByMenuNameApiArg
} from "~/api/navigationAPI.types";

import { baseAPI as api } from "~/api/baseAPI";
const injectedRtkApi = api.injectEndpoints({
    endpoints: (build) => ({
        getNavigationData: build.query<
            GetNavigationDataApiResponse,
            GetNavigationDataApiArg
        >({
            query: () => ({ url: "/navigation/data" }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        getNavigationMenus: build.query<
            GetNavigationMenusApiResponse,
            GetNavigationMenusApiArg
        >({
            query: () => ({ url: "/navigation/menus" }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
        getNavigationMenusByMenuName: build.query<
            GetNavigationMenusByMenuNameApiResponse,
            GetNavigationMenusByMenuNameApiArg
        >({
            query: (queryArg) => ({ url: `/navigation/menus/${queryArg}` }),
            extraOptions: {
                security: {
                    api_key_header: [],
                    api_key: [],
                    "jwt-token": [],
                    "jwt-cookie": [],
                    jwt: [],
                },
            },
        }),
    }),
    overrideExisting: false,
});
export { injectedRtkApi as navigationAPI };
export const {
    useGetNavigationDataQuery,
    useLazyGetNavigationDataQuery,
    useGetNavigationMenusQuery,
    useLazyGetNavigationMenusQuery,
    useGetNavigationMenusByMenuNameQuery,
    useLazyGetNavigationMenusByMenuNameQuery,
} = injectedRtkApi;
